import { NuxtAxiosInstance } from '@nuxtjs/axios'
import { keysToCamel } from '~/utility/toCamel'
import { getUrlLocaleCode } from '~~/lang/locales'
import { FlatPage, flatPageSchema } from './schema'

export class FlatPagesRepositoryFetch {
  constructor(private puFetch: NuxtAxiosInstance) {}

  async get(
    pageURL: string,
    langCode: string,
  ): Promise<FlatPage | { location: string }> {
    const response = await this.puFetch.get(this.getUrl(pageURL, langCode))
    const responseData = response.data
    if (typeof responseData.location !== 'undefined') {
      return responseData
    }
    const data = flatPageSchema.parse(keysToCamel(responseData))
    // pageURL we request is the same as current page
    data.content = this.fixHashLinks(pageURL, data.content)
    return data
  }

  private fixHashLinks(pageURL: string, content: string) {
    return content.replaceAll('href="#', `href="${pageURL}#`)
  }

  private getUrl(pageURL: string, langCode: string): string {
    const urlCode = getUrlLocaleCode(langCode)
    const prefix = urlCode ? `${urlCode}/` : ''
    return `/_/fallback/${prefix}_/static-pages/ajax/?url=${pageURL.replace(
      prefix,
      '',
    )}`
  }
}
